import { render, staticRenderFns } from "./ShopifyImage.global.vue?vue&type=template&id=449ca572&"
import script from "./ShopifyImage.global.vue?vue&type=script&lang=js&"
export * from "./ShopifyImage.global.vue?vue&type=script&lang=js&"
import style0 from "./ShopifyImage.global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports